import { useTranslation } from '../i18n/LanguageContext'

export function LanguageToggle() {
  const { lang, setLang, t } = useTranslation()
  const flag = lang === 'en' ? '🇭🇺' : '🇬🇧'
  const next = lang === 'en' ? 'hu' : 'en'
  const tip = lang === 'en' ? t('toggle.switchToHu') : t('toggle.switchToEn')

  return (
    <button
      type="button"
      onClick={() => setLang(next)}
      title={tip}
      aria-label={tip}
      className="btn btn-link p-0 ms-2 fs-5 text-decoration-none"
    >
      <span role="img" aria-hidden="true">{flag}</span>
    </button>
  )
}
